module.exports = __webpack_public_path__ + "static/media/Eating DisordersActive.8675c94f.svg";